// extracted by mini-css-extract-plugin
export default {"title":"Footer_title__Q8g5X","email":"Footer_email__rGvb4","copyright":"Footer_copyright__JQMtz"};